<div class="zone bg" #zoneContainer>
  <router-outlet (activate)="onActivate()"></router-outlet>
</div>
<div class="lazyloading" *ngIf="lazyloading">
  <div></div>
</div>

<button id="cmp-revokie-consent" class="cmp-revoke-consent" tabindex="-1" alt="" aria-hidden="true"></button>